import {alpha, Divider, Grid, Stack} from "@mui/material";
import {RootState, useAppSelector} from "../../../store";
import WishGrid from "./wish-grid/WishGrid";
import {WishSortOptions, WishType} from "../../../store/wish/Helper";
import * as React from "react";
import {ChangeEvent, Dispatch, FC, SetStateAction, useMemo} from "react";
import SearchWishTextview from "../search-wish-textview/SearchWishTextview";
import SortingSelect from "../../shared/sorting-select/SortingSelect";
import {useTranslation} from "react-i18next";
import ReactGA from "react-ga4";
import {useTheme} from "@mui/material/styles";
import WishTypePicker from "../../shared/wish-type-picker/WishTypePicker";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface Props {
    wishSorting: string,
    handleSortingChange: (value: WishSortOptions) => void
    searchText: string
    handleChangeSearchText: (e: ChangeEvent<HTMLTextAreaElement>) => void
    applySearchText: (searchText: string) => void
    type: WishType | undefined
    setType: Dispatch<SetStateAction<WishType | undefined>>
}

const DisplayWishes: FC<Props> = (props) => {
    const wishes = useAppSelector((state: RootState) => state.wishReducer.items)
    const wishesLoading = useAppSelector((state: RootState) => state.wishReducer.fetchWishesLoading)
    const {t} = useTranslation()
    const theme = useTheme()

    const handleOpenWishDetails = (wishId: string) => {
        ReactGA.event("select_item", {items: [{item_id: wishId, item_name: 'Wish - Grid Item'}]})
    }

    const gridContent = useMemo(() => {
        if (!wishesLoading && wishes.count === 0) {
            return <Typography variant="h5" color="primary"
                               fontWeight={600}
                               mt={3}>{t(props.type ? 'no_active_wishes_from_type' : 'no_active_wishes')}</Typography>
        }
        return <WishGrid wishes={wishes}
                         loading={wishesLoading}
                         handleOpenWishDetails={handleOpenWishDetails} sx={{mt: 0.5}}/>
    }, [props.type, t, wishes, wishesLoading])

    return (
        <>
            <Stack spacing={2}
                   divider={<Divider sx={{height: "2px", backgroundColor: alpha(theme.palette.primary.main, .5)}}/>}
            >
                <Grid container justifyContent='space-between' alignItems='flex-end'>
                    <Grid item xs={12} sm={6} sx={{pr: {sm: 1}}}>
                        <SearchWishTextview searchText={props.searchText}
                                            handleChangeSearchText={props.handleChangeSearchText}/>
                    </Grid>
                    <Grid item xs={12} sm={6} container justifyContent='flex-end'
                          sx={{pl: {sm: 1}, mt: {xs: "1em", sm: 0}}}>
                        <SortingSelect value={props.wishSorting}
                                       handleSortingChange={props.handleSortingChange}
                                       sortingMenuItems={
                                           Object.values(WishSortOptions).map((s) => (
                                               {
                                                   value: s,
                                                   text: t(s)
                                               }
                                           ))
                                       }/>
                    </Grid>
                </Grid>
                <Box>
                    <WishTypePicker value={props.type} handleChange={props.setType} all color="primary" sx={{mt: '6px'}}/>
                    {gridContent}
                </Box>

            </Stack>
        </>

    )
}

export default DisplayWishes
